import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './Modal.scss';
/**
 * @component Modal
 * @since 1.0.0
 */
export function Modal(props) {
    const { style, picto, title, first, hideClose, onClose, showFooterAction, footerActions, tooltip } = Object.assign({ style: 'normal' }, props);
    const className = classNames('modal', 'modal--' + style, { 'modal--first': first }, props.className);
    return (React.createElement("div", { className: className, onClick: (e) => {
            if (e.target.classList[0] === 'modal') {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        } },
        React.createElement("div", { className: "modal-window" },
            React.createElement("div", { className: "modal-window-head" },
                React.createElement("div", { className: "modal-window-container-title" },
                    picto && React.createElement(Icon, { className: "modal-window-picto", value: picto }),
                    title && React.createElement(Text, { className: "modal-window-title", value: title }),
                    tooltip && (React.createElement("div", { className: "modal-window-title-tooltip" },
                        React.createElement(Icon, { className: "modal-window-title-tooltip-picto", value: "circle-info" }),
                        React.createElement(Text, { className: "modal-window-title-tooltip-value", value: tooltip })))),
                !hideClose && (React.createElement("div", { className: "modal-window-close" },
                    React.createElement(Button, { style: "picto", picto: "xmark", onPress: onClose })))),
            React.createElement("div", { className: "modal-window-body" },
                React.createElement("div", { className: "modal-window-content" }, props.children)),
            showFooterAction && (React.createElement("div", { className: "modal-window-footer" }, footerActions)))));
}
